/**
 * @see DIRECT-89218
 * Замена для File (не работает в Edge) из FileAPI
 */

export class ExtendedBlob extends Blob {
    name: string;
    lastModified: number;

    constructor(blob: Blob, name: string, lastModified: number, type?: string) {
        super([blob], { type: type || blob.type });

        this.name = name;
        this.lastModified = lastModified;
    }
}
